module.exports = __webpack_public_path__ + "static/media/BHEL_F1.8e8951ec.txt";